import React from 'react';

import { Separator } from '@/components/design-system/separator';

interface FormSeparatorProps {
  widthClass?: string;
  text: string;
}

export const FormSeparator: React.FC<FormSeparatorProps> = ({ text, widthClass = 'w-36' }) => (
  <div className="flex items-center justify-center">
    <Separator className={widthClass} />
    <div className="flex w-16 justify-center px-4 text-black/45">{text}</div>
    <Separator className={widthClass} />
  </div>
);
